import { Button } from '@ads/components-react';
import { useTranslation } from 'react-i18next';
import { useBannerLanguageLabels } from '../../../hooks/useBannerLanguageLabels';
import type { BannerLanguage } from '../../../types/bannerForm';

export interface BannerLanguageBarProps {
  readonly current: BannerLanguage;
  readonly onChange: (language: BannerLanguage) => void;
}

/**
 * Barra de idioma do conteúdo do Banner.
 *
 * Português (BR) é a fonte de verdade; inglês e espanhol são opcionais. Trocar de
 * aba não desmonta nada — o formulário só alterna quais campos renderiza, então o
 * conteúdo digitado se mantém.
 */
export function BannerLanguageBar({ current, onChange }: BannerLanguageBarProps) {
  const { t } = useTranslation('banner');
  const languageLabels = useBannerLanguageLabels();

  return (
    <div className="flex flex-row items-center gap-micro flex-wrap rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface px-xxs py-micro shadow-level1">
      <h2 className="ts-heading-xs text-ctx-content-title">{t('banner.form.language.heading')}</h2>

      <div className="flex flex-wrap items-center gap-nano" role="tablist">
        {(Object.keys(languageLabels) as BannerLanguage[]).map(language => {
          const isCurrent = language === current;
          return (
            <Button
              key={language}
              type="button"
              role="tab"
              aria-selected={isCurrent}
              onClick={() => onChange(language)}
              size="sm"
              hierarchy={isCurrent ? 'primary' : 'secondary'}
            >
              {languageLabels[language]}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
